import styles from './FAQ.module.css';
import { useEffect } from 'react';

export default function Faq() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      q: 'Can I upgrade later?',
      a: 'Yes, you can upgrade anytime as your business grows. Your data will remain safe and intact during the transition. Upgrades are applied as per plan migration.'
    },
    {
      q: 'Do you provide industry-specific CRMs?',
      a: 'Yes, CloTech AI CRM offers modules tailored for multiple industries such as Real Estate, Vehicle Sales & Service, Education (School, College, Coaching), Pollution Testing, Restaurants & Bars, Electronics, Furniture, and more.'
    },
    {
      q: 'How is pricing calculated?',
      a: 'Pricing is based on the number of users, branches, and selected industry modules. You only pay for what you use.'
    },
    {
      q: 'Do you offer setup assistance?',
      a: 'Yes, we provide onboarding guidance, training, and configuration support to ensure your CRM is set up smoothly. Setup costs may be involved depending on requirements.'
    },
    {
      q: 'Is my data secure?',
      a: 'Absolutely. We use secure servers, data encryption, access control, and regular security checks to protect your business data.'
    },
    {
      q: 'Can I add more users or branches later?',
      a: 'Yes, additional users and branches can be added anytime. We follow fair pricing — when you add, costs will increase as per your plan or selected modules.'
    },
    {
      q: 'What support do I get?',
      a: 'Buds and Bloom plans include chat/email support. Blossom users enjoy priority support including chat, email, and optional voice support.'
    },
    {
      q: 'Do you integrate with other tools?',
      a: 'Yes, integrations are available for Email, SMS, WhatsApp, and APIs. Advanced integrations are part of the Blossom plan. Additional costs may apply.'
    },
    {
      q: 'Is customization possible?',
      a: 'Custom modules and workflows are available for Blossom customers on request. However, we release them as part of our regular updates so that all users can benefit. We believe our CRM already covers everything your industry needs — based on 6+ years of research and development.'
    },
    {
      q: 'Do you provide reports & analytics?',
      a: 'Yes, Bloom includes standard reports, while Blossom offers advanced reports and analytics dashboards.'
    },
    {
      q: 'What if my business belongs to a different industry?',
      a: 'We also provide a Generic CRM version that fits any business type. Our team can help set it up and guide you for unique requirements.'
    },
    {
      q: 'Do you offer a free trial?',
      a: 'No, but Buds (Starter Plan) is affordable and designed to get you started quickly.'
    },
    {
      q: 'Do you provide mobile access?',
      a: 'Yes, CloTech AI CRM is cloud-based and works seamlessly on desktop, tablet, and mobile browsers.'
    },
    {
      q: 'What is the minimum contract period?',
      a: 'Annual and monthly subscription options are available. You can upgrade anytime.'
    },
    {
      q: 'Do you provide training for my team?',
      a: 'Yes, we provide documentation, onboarding sessions, and remote training to ensure your team is fully equipped. For extended hand-holding support, additional costs may apply.'
    },
    {
      q: 'Can I migrate data from another CRM or Excel?',
      a: 'Yes, our team will help you import your data. If you are using another CRM, data must first be exported into Excel/CSV before we can migrate it into CloTech AI CRM.'
    },
    {
      q: 'Do you offer reseller/partner opportunities?',
      a: 'Yes, CloTech AI has a partner program where resellers and consultants can collaborate with us. If you refer a friend or family and it results in a successful implementation, we also provide additional benefits. For details, WhatsApp us at +91 9038168162.'
    }
  ];

  return (
    <div className={styles.faq}>
      <div className="container">
        <h1>Frequently Asked Questions (FAQs)</h1>
        <div className={styles.faqList}>
          {faqs.map((item, index) => (
            <div className={styles.faqItem} key={index}>
              <button className={styles.question}>
                {item.q}
              </button>
              <div className={styles.answer}>
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
